module.exports = __webpack_public_path__ + "static/img/step-3.d3d5597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step-3.png
// module id = AWbl
// module chunks = 1